var map = {
	"./address-proof.svg": 98454,
	"./approved.svg": 62379,
	"./arrow-down.svg": 85171,
	"./arrow-up.svg": 30883,
	"./cc-back.svg": 89569,
	"./cc-front.svg": 14617,
	"./id-back.svg": 29869,
	"./id-front.svg": 70229,
	"./info.svg": 95124,
	"./other.svg": 10089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91967;